<div class="card">
  <div class="card-body">
    <div class="header d-flex align-items-center justify-content-between mb-4">
      <div class="title">
        Certificates
      </div>
      @if (certificate) {
      <div class="btn-container">
        <button class="btn btn-primary">
          <svg-icon src="/assets/Icons/new/download.svg"></svg-icon>
          Download Certificate
        </button>
      </div>
      }
    </div>
    <div class="description mb-4">
      <!-- Porem ipsum dolor sit amet, consectetur adipiscing elit. Etiam eu turpis molestie, dictum est a, mattis tellus.
      Sed dignissim, metus nec fringilla accumsan, risus sem sollicitudin lacus, ut interdum tellus elit sed risus. -->
    </div>

    @if (certificate) {
    <div class="certificate text-center">
      <!-- <img class="img-fluid" src="/assets/images/certificates.png" alt=""> -->
    </div>

    }@else {
    <div class="no-certificate text-center py-5">
      <svg-icon src="/assets/Icons/new/no-certificate.svg"></svg-icon>
      <div class="title">You are on track</div>
      <div class="description">
        please come back for download your certificate. <br />
        Keep it up!
      </div>
    </div>
    }

  </div>
</div>